// ['en', 'de']

export default {
  [`Upgrade Now!`]: [
    `Upgrade Now!`,
    `Jetzt holen!`,
  ],
}
